// StatCard.js
import { HelpCircle } from "lucide-react";

const InfoTooltip = ({ content }) => (
  <div className="group relative inline-block">
    <HelpCircle className="h-4 w-5 text-gray-400 dark:text-gray-500 cursor-help" />
    <div className="invisible group-hover:visible absolute z-50 w-64 p-2 mt-2 text-sm 
                    text-white bg-gray-800 dark:bg-gray-700 rounded-lg opacity-0 group-hover:opacity-100 
                    transition-opacity duration-300">
      {content}
    </div>
  </div>
);

const ShimmerEffect = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 dark:bg-gray-700 ${className}`} />
);

export const StatCard = ({
  title,
  value,
  icon: Icon,
  description,
  isLoading,
  trend,
  tooltip,
  color = "#003087",
  showBorder = true
}) => (
  <div className={`bg-white dark:bg-slate-900 rounded-lg shadow dark:border-gray-800 ${showBorder ? 'border-l-4' : ''}`} style={showBorder ? { borderLeftColor: color } : {}}>
    <div className="p-6">
      <div className="flex justify-between">
        <div className="flex items-center space-x-2">
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">{title}</h3>
          {tooltip && <InfoTooltip content={tooltip} />}
        </div>
        <div className="p-2 bg-blue-50 dark:bg-blue-900/20 rounded-full">
          <Icon className="h-5 w-5" style={{ color }} />
        </div>
      </div>
      <div className="mt-4">
        {isLoading ? (
          <ShimmerEffect className="h-8 w-24 rounded" />
        ) : (
          <div className="flex items-baseline">
            <span className="text-2xl font-bold text-gray-900 dark:text-white">{value}</span>
            {trend && (
              <span className={`ml-2 text-sm ${trend > 0 ? "text-green-600 dark:text-green-400" : "text-red-600 dark:text-red-400"}`}>
                {trend > 0 ? "↑" : "↓"} {Math.abs(trend)}%
              </span>
            )}
          </div>
        )}
        {description && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>}
      </div>
    </div>
  </div>
);